import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { videos } from '@/mocks/videos';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = videos.slice(0, 5);

  const latestVideos = videos.slice(0, 8);
  const popularVideos = [...videos].sort((a, b) => parseFloat(b.views) - parseFloat(a.views)).slice(0, 4);

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
  };

  const pageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91免费在线视频 | 麻豆精品影视网首页',
    description: '全网最全的高清影视平台，提供海量国产精品视频在线观看',
    url: 'https://www.madoujipin.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '麻豆精品影视网',
      url: 'https://www.madoujipin.com/',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '91免费在线视频网站如何观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以直接在麻豆精品影视网免费在线观看海量高清影视资源，无需注册即可畅享最新热门影片和电视剧全集。',
        },
      },
      {
        '@type': 'Question',
        name: '麻豆精品影视网提供哪些类型的视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台提供国产剧、古装剧、历史剧、电影、综艺等多种类型的精品影视资源，支持1080P及4K高清画质在线播放。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(pageJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          {heroSlides.map((video, index) => (
            <div
              key={video.id}
              className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={video.coverImage}
                alt={video.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>
            </div>
          ))}

          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="max-w-2xl">
                  <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4">
                    热播推荐
                  </span>
                  <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3 leading-tight">
                    {heroSlides[currentSlide]?.title || '麻豆精品影视'}
                  </h1>
                  <p className="text-sm md:text-base text-white/80 mb-6 max-w-xl leading-relaxed">
                    {heroSlides[currentSlide]?.description}
                  </p>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                    <Link
                      to={`/video/${heroSlides[currentSlide]?.id}`}
                      className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                    >
                      <i className="ri-play-fill mr-1.5"></i>
                      立即观看
                    </Link>
                    <Link
                      to="/category"
                      className="px-6 py-3 bg-white/15 text-white font-medium rounded-md hover:bg-white/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                    >
                      <i className="ri-apps-2-line mr-1.5"></i>
                      浏览全部
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handlePrev}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all duration-300 cursor-pointer"
            aria-label="上一张"
          >
            <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
          </button>
          <button
            onClick={handleNext}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm rounded-full text-white transition-all duration-300 cursor-pointer"
            aria-label="下一张"
          >
            <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
          </button>

          <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentSlide
                    ? 'bg-primary-500 w-6'
                    : 'bg-white/50 hover:bg-white/80'
                }`}
                aria-label={`切换到第${index + 1}张`}
              ></button>
            ))}
          </div>
        </section>

        {/* Category Grid */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                分类浏览
              </h2>
              <Link
                to="/category"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.filter(c => c.id !== 'all').map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category?cat=${encodeURIComponent(cat.name)}`}
                  className="group bg-background-100 rounded-lg p-4 md:p-5 text-center hover:bg-primary-500 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-auto mb-2.5 md:mb-3 rounded-full bg-background-50 group-hover:bg-white/20 transition-colors">
                    <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-background-50 transition-colors whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400 group-hover:text-background-50/70 mt-1 transition-colors">
                    {cat.count}部作品
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Videos */}
        <section className="py-10 md:py-14 bg-background-100/70">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                最新上线
              </h2>
              <Link
                to="/category"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                更多新片 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
              {latestVideos.map((video) => (
                <Link
                  key={video.id}
                  to={`/video/${video.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                    <img
                      src={video.coverImage}
                      alt={video.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">
                      {video.quality}
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                      <span className="text-white text-xs">{video.duration}</span>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-400">
                    <span className="px-1.5 py-0.5 bg-secondary-100 text-secondary-800 rounded text-xs">
                      {video.category}
                    </span>
                    <span>{video.views}次播放</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Popular Ranking */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                热门排行
              </h2>
              <Link
                to="/category"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                完整榜单 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
              {popularVideos.map((video, index) => (
                <Link
                  key={video.id}
                  to={`/video/${video.id}`}
                  className="group flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg p-3 md:p-4 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center">
                    <span className={`font-heading text-lg md:text-xl font-bold ${
                      index === 0 ? 'text-primary-500' :
                      index === 1 ? 'text-accent-500' :
                      index === 2 ? 'text-secondary-500' :
                      'text-foreground-400'
                    }`}>
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <div className="flex-shrink-0 w-12 h-16 md:w-14 md:h-20 rounded overflow-hidden">
                    <img
                      src={video.coverImage}
                      alt={video.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {video.title}
                    </h3>
                    <div className="flex items-center gap-1.5 mt-1.5 text-xs text-foreground-400">
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                      </div>
                      <span>{video.rating}</span>
                      <span className="text-foreground-300">|</span>
                      <span>{video.views}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Section */}
        <section className="py-10 md:py-14 bg-background-100/70">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                影视资讯
              </h2>
              <Link
                to="/articles"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                更多资讯 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {articles.slice(0, 3).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden hover:bg-background-200/50 transition-colors cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2.5">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-800 text-xs font-medium rounded">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.publishDate}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                      <span>
                        <i className="ri-eye-line mr-1"></i>
                        {article.readCount}阅读
                      </span>
                      <span>
                        <i className="ri-user-line mr-1"></i>
                        {article.author}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-14 md:py-20 bg-background-950">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20soft%20gradient%20waves%20in%20warm%20dark%20tones%2C%20luxurious%20theater%20atmosphere%2C%20subtle%20texture%2C%20elegant%20and%20sophisticated%20mood&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative px-4 md:px-6 max-w-7xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-3">
              立即开启高清观影之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-300 mb-6 max-w-xl mx-auto leading-relaxed">
              海量精品影视资源，高清画质流畅播放，随时随地享受极致观影体验
            </p>
            <Link
              to="/category"
              className="inline-flex px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-play-circle-line mr-2"></i>
              免费开始观看
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}